/* TZAMPAS Reviews — Fallback-Logik.
   Wenn das Judge.me-Carousel nach kurzer Zeit keine Bewertungen geladen hat
   (z. B. App-Embed/Featured-Reviews noch nicht konfiguriert), zeige die
   manuellen Fallback-Karten, damit die Sektion nie leer wirkt.
   Sobald Judge.me Bewertungen liefert, bleibt das dynamische Carousel sichtbar. */
(function () {
  function check(section) {
    var carousel = section.querySelector('.jdgm-carousel');
    var fallback = section.querySelector('[data-jdgm-fallback]');
    if (!carousel || !fallback) return;
    var populated = carousel.children.length > 0 || carousel.textContent.trim().length > 0;
    if (populated) {
      fallback.hidden = true;
    } else {
      fallback.hidden = false;
      var w = section.querySelector('.jdgm-carousel-widget');
      if (w) w.style.display = 'none';
    }
  }
  function boot() {
    document.querySelectorAll('.tz-rev[data-mode="judgeme"]').forEach(function (s) {
      setTimeout(function () { check(s); }, 4000);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* TZAMPAS Reviews — dynamischer Scroll-Fade (#13).
   Setzt --fade-l/--fade-r am .tz-rev__track je nach Scroll-Position:
   links erst, wenn nach links Inhalt liegt; rechts, solange mehr folgt.
   Reines JS → gleiches Verhalten auf iPhone und Mac. */
(function () {
  /* Exakte Gutter-Breite in px ermitteln — aus dem tatsächlich aufgelösten
     padding-inline-start des Tracks (clamp(20px,5vw,64px) → konkreter px-Wert).
     Wir schreiben px statt var(--tz-gut) in die Maske, weil iOS-Safari die
     Maske bei einer var()-Änderung nicht zuverlässig neu rendert. Die Fade-
     Breite entspricht damit GENAU dem Weißraum bis zur ersten Kartenkante. */
  function gutterPx(track) {
    /* #13 iOS-Fix: Der Gutter wird jetzt als margin-inline-start an der ERSTEN
       Karte erzeugt (nicht mehr als padding-inline am Track). Zuerst dort lesen;
       Fallback auf Track-Padding (falls sich das Markup mal ändert) und zuletzt
       scroll-padding-inline-start. So bleibt die Fade-Breite exakt = Weißraum. */
    var first = track.querySelector('.tz-rev__card:first-child');
    if (first) {
      var m = parseFloat(window.getComputedStyle(first).marginInlineStart || '0');
      if (isFinite(m) && m > 0) return m;
    }
    var cs = window.getComputedStyle(track);
    var p = parseFloat(cs.paddingInlineStart || cs.paddingLeft || '0');
    if (isFinite(p) && p > 0) return p;
    var sp = parseFloat(cs.scrollPaddingInlineStart || '0');
    return (isFinite(sp) && sp > 0) ? sp : 0;
  }
  function update(track) {
    var max = track.scrollWidth - track.clientWidth;
    var x = track.scrollLeft;
    var atStart = x <= 2;
    var atEnd = max <= 0 || x >= max - 2;
    var g = gutterPx(track) + 'px';
    /* Links: 0 solange nicht gescrollt; sonst exakt Gutter-Breite (endet an der
       linken Kartenkante, reicht nie über die Karte). Rechts analog. */
    track.style.setProperty('--fade-l', atStart ? '0px' : g);
    track.style.setProperty('--fade-r', atEnd ? '0px' : g);
  }
  function bind(track) {
    if (track.__tzFade) { update(track); return; }
    track.__tzFade = true;
    /* Robuster Init: VOR dem ersten Scroll garantiert kein linker Fade. */
    track.style.setProperty('--fade-l', '0px');
    track.style.setProperty('--fade-r', '0px');
    update(track);
    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(function () { update(track); });
    }, { passive: true });
    if (window.ResizeObserver) {
      new ResizeObserver(function () { update(track); }).observe(track);
    }
  }
  function boot() {
    document.querySelectorAll('.tz-rev__track').forEach(bind);
    /* Fallback-Track wird evtl. erst nach dem Judge.me-Check sichtbar → nachfassen */
    setTimeout(function () {
      document.querySelectorAll('.tz-rev__track').forEach(bind);
    }, 4200);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('resize', function () {
    document.querySelectorAll('.tz-rev__track').forEach(update);
  }, { passive: true });
})();
